<template>
    <div 
        class="card-container"
    >
        <a-card
            hoverable
            bordered
            :style="{
                width: '300px',
            }"
            :class="{
                'file-selected': fileSelected,
                'card-wrap': emphasized
            }"
        >
            <a-card-meta
                class="card-body"
            >   
                <a-icon slot="avatar"
                    type="book"
                    :style="{
                        fontSize: '35px'
                    }"
                />
                <template slot="title">
                    <div class="ant-card-meta-title">
                        {{ folderObj.name }}
                    </div>
                </template>
                <div slot="description">
                    <div class="description-holder">
                        {{ displayDate(folderObj.modifiedAt.date) }}
                    </div>
                    <div class="description-holder">
                            <div class="priority-container">
                                <a-rate
                                    :allowClear="false"
                                    :disabled="true"
                                    :count="5"
                                    :defaultValue="folderObj.priority"
                                    :value="folderObj.priority"
                                >
                                    
                                </a-rate>
                            </div>
                        </div>
                    <template v-if="detailed">
                        <div 
                            class="description-holder"
                        >
                            {{ folderObj.description }}
                        </div>
                        <div class="description-holder"
                            v-if="folderObj.persons.length > 0"
                        >
                            <div class="tags-title">
                                Kiről szól?
                            </div>
                            <div class="tags-container">
                                <a-tag v-for="tag in folderObj.persons"
                                    :key="tag.id"
                                    class="tag-colorized"
                                >
                                    {{ tag.name }}
                                </a-tag>
                            </div>
                        </div>
                        <div class="description-holder"
                            v-if="folderObj.topics.length > 0"
                        >
                            <div class="tags-title">
                                Témakör
                            </div>
                            <div class="tags-container">
                                <a-tag v-for="tag in folderObj.topics"
                                    :key="tag.id"
                                    class="tag-colorized"
                                >
                                    {{ tag.name }}
                                </a-tag>
                            </div>
                        </div>
                        <div class="description-holder"
                            v-if="folderObj.tags.length > 0"
                        >
                            <div class="tags-title">
                                Egyéb címke
                            </div>
                            <div class="tags-container">
                                <a-tag v-for="tag in folderObj.tags"
                                    :key="tag.id"
                                    class="tag-colorized"
                                >
                                    {{ tag.name }}
                                </a-tag>
                            </div>
                        </div>                        
                    </template>
                </div>
            </a-card-meta>

            <template class="card-actions"
                v-if="!viewOnly"
                slot="actions"
            >
                <a-icon type="file-add" 
                    v-if="!fileSelected"
                    v-on:click="addFile"
                />
                <a-icon 
                    type="close-circle"
                    v-if="fileSelected"
                    v-on:click="removeFile"
                />
                <a-icon type="eye" 
                    v-on:click="checkFile"
                />
            </template>
            <template
                v-if="viewOnly"
                class="card-actions"
                slot="actions"
            >
                <a-icon 
                    :type="detailed ? 'up' : 'down'"
                    v-on:click="toggleDetailed"
                />
                <a-icon type="eye" 
                    v-on:click="checkFile"
                />
            </template>
        </a-card>
    </div>
</template>

<script>
import uuidv4 from 'uuid/v4';
import { SELECT_INFO, REMOVE_INFO_SELECTION } from '@/store/mutation_types';
import moment from 'moment';
import { defaultFolderObj } from '../../../helpers/defaultProps';

export default {


    props: {
        folderObj: {
            type: Object,
            default: () => defaultFolderObj()
        },
        viewOnly: {
            type: Boolean,
            default: true
        },
        forceDetailed: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {

            fileTypeIcons: {
                info: 'book'
            },
            manualDetailed: false
        }        
    },

    computed: {
        fileSelected() {
            if (this.viewOnly) {
                return false;
            } else {
                return this.$store.getters.getInfoSelectedState(this.folderObj.uuid);
            }
        },
        detailed() {
            if (this.forceDetailed) {
                return this.forceDetailed;
            } else {
                return this.manualDetailed
            }
        },
        emphasized() {
            if (this.folderObj.isEmphasized) {
                return true
            } else {
                return false;
            }
        }
    },

    methods: {
        addFile(event) {
            event.preventDefault();
            this.$store.commit({
                type: SELECT_INFO,
                infoObj: this.folderObj
            })
        },
        checkFile(event) {
            event.preventDefault();
            this.$router.push({
                path: `/app/folders/${this.folderObj.uuid}`
            })
        },
        removeFile(event) {
            event.preventDefault();
            this.$store.commit({
                type: REMOVE_INFO_SELECTION,
                uuid: this.folderObj.uuid
            })
        },
        displayDate(dateString) {
            return moment(dateString).format('YYYY-MM-DD')
        },
        toggleDetailed() {
            this.manualDetailed = !this.manualDetailed;
        }
        
    }
}
</script>

<style lang="scss" scoped>
    .description-holder {
        margin-bottom: 10px;
        color: black;
    }
    .card-container {
        transition: all 0.2s ease-in-out;
        margin-left:auto;
        margin-right: auto;
        .file-selected{
            background-color: #77fd77;
        }
    }
    .extra-actions {
        border-top: 1px solid #e8e8e8;
        padding-top: 15px;
    }
    
    .card-wrap {
        background: linear-gradient(#ff6a0085 0%, white 100%);
    }
    .tag-colorized {
        background-color: $primary-blue;
        color: white;
    }
    .card-body {
        min-height: 180px;
    }
</style>
